/**
 * Convert bytes -> megabytes
 * @param bytes number
 * @param fractionDigits number of decimal places (default: 2)
 */
export const bytesToMB = (
  bytes: number,
  fractionDigits = 2
): number => {
  return Number((bytes / (1024 * 1024)).toFixed(fractionDigits));
};

/**
 * Convert megabytes -> bytes
 * @param mb number
 */
export const MBToBytes = (mb: number): number => {
  return Math.round(mb * 1024 * 1024);
};